export enum AppTheme {
  light = 'light-theme',
  dark = 'dark-theme',
}
